<template>
  <div class="productSummaryPanel">
    <checkout-product-list v-if="project" :project="project"></checkout-product-list>
    <v-container fluid class="d-flex">
      <v-row>
        <v-col cols="12">
          <v-row justify="space-between">
            <v-col cols="auto">
              <v-btn rounded color="#F4F2F7" class="sigfloButtonSmall text-capitalize" @click="openProject(project.id)"
                ><v-icon color="" class="mr-2">mdi-arrow-left-circle-outline </v-icon>Back to Project</v-btn
              >
            </v-col>
            <v-col cols="auto">
              <v-btn dark color="#7C40DC" rounded class="sigfloButtonSmall text-capitalize" @click="$emit('next-step')">
                Proceed to Payment<v-icon color="white" class="ml-2">mdi-arrow-right-circle-outline </v-icon></v-btn
              ></v-col
            >
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import CheckoutProductList from './CheckoutProductList.vue';
  export default {
    components: {
      CheckoutProductList
    },
    props: {
      project: Object
    },
    data() {
      return {};
    },
    methods: {}
  };
</script>

<style scoped>
  .productSummaryPanel {
    max-width: 1200px;
  }
</style>
